<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Schema"
            bc1="App"
            bc2="Schema"
            bc3="List"
            path="schemas"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-4 col-sm-6">
                <SelectOptions
                    label=""
                    :hideLabel="true"
                    selectAppend="currency"
                    labelValue="code"
                    :filter="{ flag: 'active' }"
                    :modelValue.sync="selectedAccount"
                    url="v1/get-currency"
                />
              </div>
              <div class="col-md-4 col-sm-6">
                <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
              </div>
              <div class="col-md-4 col-sm-12">
                <button type="button" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
                <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="$router.push({ name: 'add-schemas' })"
                  >
                    <AddButtonText name="Schema" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
            :url="url"
            :tableHeaderValues="tableHeaderValues"
            :actions="actions"
            :deleteActions="deleteActions"
            :showPerPage=true
            :mutedData="mutedData"
            :storageKey="storageKey"
            :externalTotalRecord="externalTotalRecord"
            :filteredData="filteredData"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import {CommandIcon} from "vue-feather-icons";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  props: ['propFilters'],
  components: {
    AddButtonText,
    CommandIcon
  },
  mounted() {
    localStorage.setItem("url", "v1/get-schema");
    this.checkDataInStore('v1/get-schema')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    if(typeof(this.propFilters) != 'undefined'){


      let filterData = {}

      if(this.propFilters.currentPage){
        filterData.page = this.propFilters.currentPage
      }

      if(this.propFilters.search){
        this.search = this.propFilters.search
        filterData.search = this.search
      }

      if(this.propFilters.selectedAccount){
        this.selectedAccount = this.propFilters.selectedAccount
        filterData.selectedAccount = this.selectedAccount
        filterData.currencyId = this.selectedAccount.id
      }

      this.filteredData = filterData
    }
  },
  data() {
    return {
      currentPage: 1,
      search: '',
      selectedAccount: null,
      url: "v1/get-schema",
      storageKey: "schemaMain",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true,
          alter: (value, row) => {
            var html = "";
            if (value) {
              html = `<span class="text-dark font-medium-1 font-weight-bold">${value}</span>`;
              if (row.description) {
                html = `
                <div class="row">
                <div class="col-12">
                <span class="text-dark font-medium-1 font-weight-bold ">${value}</span>
                </div><small ><div class="text-primary ml-1" style="margin-top: 0.3rem">${row.description}</div></small></div>`
              }

              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: 'Type',
          valueKey: 'type',
          html: true,
          alter: (value,row) => {
            let typeList = ['Other','CardPayment','Applepay','Googlepay']
            let html = ` <div  class="text-secondary">${typeList[value] ?? ''}</div>`


            return  html


          }
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function (value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Smart Routing",
          valueKey: "smart_routing",
          html: true,
          alter: function (value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-light-info badge-sm">Yes</span>`;
            } else {
              html = `<span class="badge badge-light-warning badge-sm">No</span>`;
            }
            return html;
          }
        },
        {
          title: "Currency",
          valueKey: "currency.code",
          html: true,
          alter: function (value, row) {
            var html = "";
            if (value) {
              html = `<span class="badge badge-success badge-glow badge-sm">${value}</span>`;
            }
            return html;
          }
        },
        {
          title: 'Created At',
          valueKey: 'created_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
        {
          title: 'Updated At',
          valueKey: 'updated_at',
          html:true,
          alter: (value) => {
            return `<span class="badge text-dark">${this.customFormatDateTime(value)}</span>`
          }
        },
      ],
      actions: [
        {
          title: "Groups",
          class: "badge btn-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "acquiringGroups"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "schema-groups",params: {schemaId : btoa(row.id)}})
          }
        },
        {
          title: "Acquirings",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "acquiringSchemaDetailsList"
            };
            this.$store.dispatch("set", data);
            let propFilters = this.filteredData
            propFilters.currentPage = this.currentPage
            this.$router.push({name: "acquiring-details",params: {propFilters: propFilters}});
          }
        },
        {
          title: "Update",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "schemaMainUpdate"
            };
            this.$store.dispatch("set", data);
            this.$router.push({name: "update-schemas"});
          }
        },
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "schemaDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: "",
      filteredData: {},
    };
  },
  methods: {
    onSubmitFilters() {

      let filterData = {}

      if(this.selectedAccount){
        filterData.selectedAccount = this.selectedAccount
        filterData.currencyId = this.selectedAccount.id
      }
      if(this.search != ''){
        filterData.search = this.search
      }


      this.filteredData = filterData




    },
    clear(){
      this.selectedAccount = null
      this.search = ''
      this.filteredData = {}

    },
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-schema", {
        status: data.row.status == true ? 1 : 0,
        schemaId: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey(this.storageKey);
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "schemaMain";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>

